<template>
  <div class="Pathway">
      <b-container>
                <b-row >
                    <b-col lg="12" md="12" sm="12">
                        <h2 class="heading">Your Pathway to the DP World Tour</h2>
                    </b-col>
                </b-row>
                <div id="loaderClasstwo" class="loaderSection">
                <div class="loader"></div>
                <h2 class="loading">Loading...</h2>
                </div>
                <b-row >
                    <b-col lg="3" sm="6" v-for="(tour, index) in acf" :key="'path'+ index" class="pathwayImages">
                        <b-link :to="tour.tour_link">
                            <img class="tourImage" :src="tour.tour_image">
                        </b-link>
                    </b-col>
                </b-row>
      </b-container>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Pathway',
  components: {

  },
  data: function() {
    return {
      acf: [],
    };
  },
  methods: {
    isMobile() {
        if( screen.width <= 500 ) {
            return true;
        }
        else {
            return false;
        }
    },
  },
  mounted() {
    axios //add API Call
        .get(
            'https://wp-cpt.ocs-software.com/' + "/wp-json/wp/v2/pages/8"
        ) // Page number changed on each page based on JSON page id you are calling
        .then((response) => (
            this.acf = response.data.acf.pathway,
            setTimeout(function(){
                document.getElementById('loaderClasstwo').remove();
            }, 2000)
        )); //API data wanted pulled out
  },
}
</script>

<style scoped>
h2.loading {
  padding-top: 20px;
  font-weight: 600;
  font-size: 24px;
  color: #081C3F;
  text-align: center;
  /* padding-bottom: 90px; */
}
.loader {
  border: 16px solid #f3f3f3; /* Light grey */
  border-top: 16px solid #081C3F; /* Blue */
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
  margin: auto;
  display: block;
}
.loaderSection {
  padding-top: 30px;
  padding-bottom: 30px;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
img.tourImage {
    width: 100%;
    margin-bottom: 30px;
    transition: all 0.4s ease;
    /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
    transition: all 350ms cubic-bezier(.37, 0, .63, 1);
    border-radius: 6px;
}
img.tourImage:hover {
    transform: translateY(-10px);
    border-radius: 6px;
}
.below768.belowSec {
    margin-top: 35px;
}
.noPadMob.col-sm-2 {
    width: 25%;
}
.noPadMob.col-sm-10 {
    width: 75%;
}
.signature {
    width: 200px;
}
.itemRow {
    margin-bottom: 80px;
}
.itemsTitle {
    color: #081C3F;
    font-size: 40px;
}
.Leftimage {
    width: 87px;
    height: 87px;
}
.Allbuttons {
    width: 420px;
    height: 50px;
    background: transparent;
    color: #fff;
    /* font-weight: 500; */
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
    border-radius: 30px;
    border: 1px solid #081C3F;
    font-size: 16px;
    position: absolute;
    bottom: 0;
    transition: all 0.4s ease;
    /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
    transition: all 350ms cubic-bezier(.37, 0, .63, 1);
}
.Allbuttons:hover {
    width: 420px;
    height: 50px;
    background: #081C3F;
    color: #fff;
    /* font-weight: 500; */
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
    border-radius: 30px;
    border: 1px solid #E8E8E8;
    position: absolute;
    bottom: 0;
    transform: translateY(-10px);
}
.arrow {
    width: 14px;
    height: 12px;
}
.noPad {
    /* padding: 0; */
}
.Pathway {
    padding: 3%;
    padding-bottom: 90px;
    /* padding-top: 90px; */
}
.heading {
    /* font-weight: 600; */
    font-size: 36px;
    color: #081C3F;
    text-align: center;
    padding-bottom: 90px;
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
}
/* mobile code */
.containterInside.container.mobContainer {
    padding-top: 40px;
    padding-bottom: 40px;
}
/* End of mobile code */
.description {
    text-align: left;
    margin-top: 30px;
    margin-bottom: 30px;
    color: #081C3F;
    font-size: 20px;
}
.space {
    margin-top: 30px;
}
.bkImageFull {
    background-color: #000000; /* For browsers that do not support gradients */
}
.containterInside {
    padding-top: 100px;
    padding-bottom: 100px;
}
h2.MainTitle {
    font-size: 28px;
    color: #9CD58A;
    font-weight: bold;
    text-align: left;
}
.image {
    width: 100%;
}
.itemsLeft {
    text-align: left;
    color: #081C3F;
    font-size: 20px;
    /* display: flex; */
    margin-bottom: 20px;
}
.SubTitle {
    color: #9CD58A;
    font-size: 20px;
    font-weight: bold;
    text-align: left;
    margin-top: 30px;
    margin-bottom: 20px;
}
.belowSec {
    padding-top: marpx;
}
@media only screen and (min-width: 769px) {
    .below768 {
        display: none;
    }
}
@media only screen and (max-width: 500px) {
    .pathwayImages.col-sm-6.col-lg-4:nth-child(odd){
        padding-right: 10px;
    }
    .pathwayImages.col-sm-6.col-lg-4:nth-child(even){
        padding-left: 10px;
    }
    img.tourImage {
        width: 100%;
        margin-bottom: 20px;
        transition: all 0.4s ease;
        transition: all 350ms cubic-bezier(.37, 0, .63, 1);
    }
    .col-sm-6.col-lg-4 {
        width: 50%;
    }
    .Pathway {
        padding-top: 25px;
        padding: 0%;
    }
    .heading {
        /* font-weight: 600; */
        font-size: 24px;
        color: #081C3F;
        text-align: left;
        padding-bottom: 25px;
        font-family: "brown-pro-condensed", sans-serif;
        font-weight: 800;
        font-style: normal;
    }
}
@media only screen and (max-width: 768px) {
    .above768 {
        display: none;
    }
    .itemRow {
        margin-bottom: 20px;
        margin-top: 30px;
    }
    .noPad.col-lg-3 {
        text-align: center;
    }
    .itemsTitle{
        color: #081C3F;
        font-size: 25px;
        text-align: left;
    }
    .itemsLeft {
        text-align: left;
        color: #081C3F;
        font-size: 18px;
        /* display: flex; */
        margin-bottom: 20px;
    }
    .Leftimage {
        width: 60px;
        height: 60px;
    }
    .Message {
        background-color: #fff;
        padding: 3%;
        padding-bottom: 25px;
        padding-top: 25px;
    }
    .Pathway {
        padding-bottom: 0px;
        padding-top: 25px;
    }
}
@media only screen and (max-width: 510px) {
    .Pathway {
        padding-bottom: 0px;
    }
}
</style>
